import { LockOpenIcon } from '@heroicons/react/24/outline'
import { useChat } from '../../providers/chat/context'

export default function PermissionsPanel({ heading = true }: { heading?: boolean }) {
  const { permissions, revoke } = useChat()

  return (
    <div className="flex flex-col gap-3 py-3">
      {heading && (
        <div className="px-3">
          <h3 className="text-[11px] font-semibold tracking-wide text-stone-500 uppercase">
            Always-allowed actions
          </h3>
          <p className="mt-1 text-[11px] leading-relaxed text-stone-500">
            Actions you've approved for this brand with "Always allow". Revoking makes the assistant ask
            again next time.
          </p>
        </div>
      )}

      {permissions.length === 0 ? (
        <p className="mx-3 rounded-md border border-dashed border-stone-200 px-3 py-4 text-center text-[11px] text-stone-400">
          No always-allowed actions yet.
        </p>
      ) : (
        <ul className="flex flex-col">
          {permissions.map((permission) => (
            <li
              key={`${permission.tool_name}:${permission.action}`}
              className="flex items-center gap-2 px-3 py-2 text-xs text-stone-700 hover:bg-stone-200"
            >
              <LockOpenIcon className="size-3.5 shrink-0 text-emerald-500" />
              <div className="min-w-0 flex-1">
                <p className="truncate font-mono text-[11px] text-stone-800">{permission.tool_name}</p>
                <p className="text-[10px] tracking-wide text-stone-400 uppercase">{permission.action}</p>
              </div>
              <button
                type="button"
                onClick={() => void revoke(permission.tool_name, permission.action)}
                className="text-[11px] text-rose-600 transition hover:text-rose-800"
              >
                Revoke
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
